/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {Glyphicon} from "../../../../Common/GlyphIcon";
import React from "react";
import {usePermission} from "../../../../../Hooks/PermissionHooks";

export const SpeciesRequestActionTableColumn = function (props) {
	const hasPermission = usePermission();
	const {OnEditClick, Value, rowData: species = {}, EditableChecker} = props;
	const {speciesId} = species;
	if (!species || !Value) return <span>N/A</span>;

	const canEdit =  hasPermission?.('can_alter_global_species_list');
	const editButtonLabel = canEdit ? 'Review' : 'Details';

	return <div className="actions">
		{
			OnEditClick &&
			<a className="link-primary" onClick={_ => OnEditClick?.(speciesId)} title="Review">
				<Glyphicon glyph="ballot-check"/>&nbsp;{editButtonLabel}
			</a>
		}
	</div>;
};
